import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../Services/PaymentType"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

const PaymentType = () => {
    const [type, setType] = useState("");
    const [typeList, setTypeList] = useState([]);
    const [errors, setErrors] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const perPage = 10;
    const [isEditing, setIsEditing] = useState(false);
    const [id, setId] = useState([])
    const [highlight, setHighlight] = useState(false);
    const [createdDate, setCreatedDate] = useState("")
    const [status, setStatus] = useState("")

    useEffect(() => {
        bindPaymentType();
    }, [currentPage])


    const bindPaymentType = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage
            };
            const response = await API.getPaymentType(payload);
            const details = response?.data?.data;
            console.log("detailssss", details)
            setTypeList(details.rows);
            setTotalRecords(details.count)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };



    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // bindPaymentType();
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };






    const validateFields = () => {
        const errors = {};
        if (!type.trim()) {
            errors.type = "Type is required";
        } else if (!/^[a-zA-Z\s]+$/.test(type)) {
            errors.type = "Only letters and spaces are allowed";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "type":
                setType(value);
                break;
            default:
                break;
        }
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        const payload = {
            type: type
        };
        try {
            const response = await API.createPaymentType(payload);
            console.log(response.data);
            if (response.status === 200) {
                toast.success(response.data.message);
                setTimeout(() => window.location.reload(), 2000);
            } else {
                setTimeout(() => window.location.reload(), 2000);
            }
        } catch (error) {
            console.error("Error during API call:", error);
            console.log(error.response.status);
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            if (error.response) {
                toast.error(`Error: ${error.response.data.message || error.response.statusText}`);
            } else if (error.request) {
                toast.error("No response from server. Please try again later.");
            } else {
                toast.error(`Error: ${error.message}`);

            }
        }
    };

    const handleStatusToggle = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.updateStatus(id, updatedStatus);
            if (response.status === 200) {
                setTypeList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(response.data.message);
                bindPaymentType();
            } else {
                toast.error("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");

            }
        } catch (error) {

            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            else {
                toast.error("Failed to update the status. Please try again.");
            }
        }
    };

    const handleGetData = async (id) => {
        try {
            setId(id);
            const response = await API.getPaymentType({ id: id });
            const fetchedData = response?.data?.data?.rows?.[0];
            console.log("fetch data", fetchedData)
            if (fetchedData) {
                setHighlight(true);
                setType(fetchedData.type);
                setCreatedDate(fetchedData?.createdAt)
                setStatus(fetchedData?.is_active)
                setIsEditing(true);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });

            } else {
                toast.error("Failed to fetch designation details.");
            }
        } catch (error) {
            console.log(error.response.status);
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            else {
                toast.error("Error fetching data:", error);
            }

        }
    };



    const handleUpdate = async () => {
        if (!validateFields()) return;
        const payload = {
            type: type
        };
        try {
            const response = await API.updatePaymentType(id, payload);
            if (response.status === 200) {
                toast.success(response.data.message);
                bindPaymentType();
                setTimeout(() => window.location.reload(), 2000);

            } else {
                toast.error('Unexpected status:', response.status, response.data.message);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    toast.error('Resource not found (404)');
                }
                else if (error.response.status === 403) {
                    window.location.replace("/Login");
                }
                else {
                    toast.error(`Error: ${error.response.data.message || 'Something went wrong'}`);
                    //   console.error('Error response:', error.response);
                }
            } else if (error.request) {
                // console.error('No response received:', error.request);
                toast.error('No response from the server. Please try again.');
            } else {
                // console.error('Error:', error.message);
                toast.error('An error occurred. Please try again', error.message);
            }
        }
    };

    const handleCancel = () => {
        setType("")
        window.location.reload();
    }


    return (
        <div>
            <div >
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div
                            className={`card ${highlight ? "highlight" : ""}`}
                            style={{
                                backgroundColor: highlight ? "#fff" : "white",
                                transition: "background-color 0.3s ease",
                            }}>
                            <div className="card-body">
                                <h4 className="card-title">Payment Type <span style={{ color: "red" }}>*</span></h4>
                                <div className="forms-sample">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="name">Type</label>
                                                <input
                                                    type="text"
                                                    id="txtType"
                                                    placeholder="Type"
                                                    className={`form-control ${errors.type ? "is-invalid" : ""}`}
                                                    value={type}
                                                    onChange={(e) => handleFieldChange(e, "type")}
                                                />
                                                {errors.type && (
                                                    <div className="invalid-feedback">{errors.type}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        {/* <button type="button" className="btn btn-primary me-2" onClick={handleSubmit}>
                                            Submit
                                        </button> */}
                                        <button
                                            type="button"
                                            onClick={handleSubmit}
                                            className="btn btn-primary me-2"
                                            style={{ display: isEditing ? "none" : "inline-block" }}>
                                            Submit
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleUpdate}
                                            className="btn btn-primary me-2"
                                            style={{ display: isEditing ? "inline-block" : "none" }}
                                        >
                                            Update
                                        </button>
                                        <button onClick={handleCancel} className="btn btn-light">Cancel</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Payment Type</h4>
                    </div>
                    <div className="card-body">
                        <table className="table table-bordered text-center">
                            <thead>
                                <tr>
                                    <th>SrNo</th>
                                    <th>Action</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Created-Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {typeList.map((item, index) => (
                                   
                                    <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                                        {/* <td>
                                            <button className="btn btn-success btn-sm" onClick={() => handleGetData(item.id)}>Edit</button>{' '}
                                            <button
                                                className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                onClick={() => handleStatusToggle(item.id, item.is_active)}>
                                                {item.is_active ? "Deactivate" : "Activate"}
                                            </button>
                                        </td> */}

                                        <td>
                                            <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                <ul className="navbar-nav navbar-nav-right">
                                                    <li className="nav-item nav-profile1">
                                                        <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <div className="nav-profile-text1">
                                                                <p className="mb-1 text-black">
                                                                </p>
                                                            </div>
                                                        </span>
                                                        <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                        <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                            <a className="dropdown-item">
                                                                <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                                                    View
                                                                </button>
                                                            </a>
                                                            <div className="dropdown-divider"></div>
                                                            <a className="dropdown-item">
                                                                <button className="btn btn-primary btn-sm" onClick={() => handleGetData(item.id)}>Edit</button>{' '}

                                                            </a>
                                                            <div className="dropdown-divider"></div>
                                                            <a className="dropdown-item">
                                                                {/* {localStorage.getItem("location_id") !== item.id && ( */}
                                                                <button
                                                                    className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                    onClick={() => handleStatusToggle(item.id, item.is_active)}
                                                                >
                                                                    {item.is_active ? "De-Activate" : "Activate"}
                                                                </button>
                                                                {/* )} */}
                                                            </a>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>{item.type}</td>
                                        <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                        <td>
                                            {moment(item.createdAt).format("DD-MM-YYYY")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center mt-4">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>
                                {/* {Array.from({ length: totalPages }, (_, index) => (
                                    <li
                                        key={index + 1}
                                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                            {index + 1}
                                        </button>
                                    </li>
                                ))} */}
                                {getPageNumbers().map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                    >
                                        {page === "..." ? (
                                            <span className="page-link">...</span>
                                        ) : (
                                            <button className="page-link" onClick={() => handlePageChange(page)}>
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                                <li
                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>

                </div>
            </div>
            <ToastContainer />
            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Payment Type Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>Payment Type</th>
                                                            <th>Created Date</th>
                                                            <th>Status</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{type}</td>
                                                            <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                            <td>{status ? "Active" : "De-Activated"}</td>
                                                        </tr>

                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default PaymentType;